import {
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import * as _ from "lodash";
import moment from "moment";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NbcLoggerService } from "../../shared/logger/nbc-logger.service";
import { SubSink } from "subsink";
import { SharedDataService } from "../../shared/sharedData.service";
import { LookUpService } from "../../shared/services/lookup.service";
import { StudioPayrollService } from "../../shared/services/studio-payroll.service";
import { EventBusService } from "../../core/services/event-bus.service";
//import { error } from "@angular/compiler/src/util";

@Component({
    selector: "app-archive-export",
    templateUrl: "./archive-export.component.html",
    standalone: false
})
export class ArchiveExportComponent implements OnInit, OnDestroy {
    // self :any = this;

    constructor(
        private _modalService: BsModalService,
        private _lookupService: LookUpService,
        private _sharedDataService: SharedDataService,
        private _sharedService: SharedDataService,
        private _eventBusService: EventBusService,
        private _studioPayrollService: StudioPayrollService,
        private log: NbcLoggerService
    ) {}

    private subs = new SubSink();
    businessUnitId: any;
    selectedBusinessUnit: any;
    paymentExportsTypes: any = [];
    paymentExports: any = [];
    archivedFiles: any = [];
    property: any = [];

    selectedExportType: any = "";
    exportTypeFilesAvailalble: any = false;
    showArchivedFiles: any = false;

    query: any = {
        businessUnitId: "",
        Path: "",
    };

    onBreadcrumb(goto) {
        switch (goto) {
            case "step1":
                //must show only export types. Hide others
                this.query.path = "";
                this.GetAvailableExportTypes("paymentExportsTypes");
                this.selectedExportType = "";
                this.exportTypeFilesAvailalble = false;
                this.showArchivedFiles = false;
                this.archivedFiles = [];
                this.paymentExports = [];
                break;
            case "step2":
                if (!this.exportTypeFilesAvailalble) {
                    this.archivedFiles = [];
                    this.paymentExports = [];
                    this.showArchivedFiles = false;
                    this.exportTypeFilesAvailalble = true;
                    this.query.path = this.selectedExportType;
                    this.GetAvailableExportTypes("paymentExports");
                }
                break;
        }
    }

    /*
     * Method will return list of directories
     **/
    GetAvailableExportTypes(property) {
        this.log.trace("getAvailableExportTypes");
        this._studioPayrollService.get(this.query).subscribe({
            next: (result) => {
                this.log.trace("payment export get" + JSON.stringify(result));
                this[property] = result.reference;

                //this.paymentExportsTypes = result.reference;
                //this.paymentExports = result.reference;
                //this.archivedFiles = result.reference;
                //self[property] = result.reference;
            },
            error: (err) => {
                this.log.error(
                    "payment export get got an error: " + JSON.stringify(err)
                );
                // this.$emit("showAlert", "danger", "Unable to load payment sources at this time.", "alert");
            },
        });
    }

    onExportTypeSelected(exportType) {
        this.paymentExports = [];
        this.archivedFiles = [];
        this.selectedExportType = exportType;
        this.exportTypeFilesAvailalble = true;
        this.query.path = this.selectedExportType;
        this.GetAvailableExportTypes("paymentExports");
    }

    subscribeEventHandlers() {
        this.subs.sink = this._sharedDataService
            .getSelectedBusinessUnit()
            .subscribe((selectedBu) => this.onBusinessUnitSelected(selectedBu));

        this.subs.sink = this._eventBusService.on(
            "reloadStudioPayroll",
            (data) => this.onBreadcrumb("step1")
        );
    }

    onBusinessUnitSelected(data: any) {
        this.selectedBusinessUnit = data;
        this.businessUnitId = this.selectedBusinessUnit.id;
        this.query.businessUnitId = this.selectedBusinessUnit.id;
        this.GetAvailableExportTypes("paymentExportsTypes");
    }

    onArchieveClicked() {
        this.paymentExports = [];
        this.archivedFiles = [];
        this.showArchivedFiles = true;
        this.exportTypeFilesAvailalble = false;
        this.query.path = this.selectedExportType + "/Archive";
        this.GetAvailableExportTypes("archivedFiles");
    }

    downloadFile(fileName) {
        this.query.fileName = fileName;

        this._studioPayrollService.downloadFile(this.query).subscribe({
            next: (result) => {
                this.log.trace(
                    "exported report got data" + JSON.stringify(result)
                );
                if (result === 204) {
                    // show message for no data points
                    this.log.showModalError(
                        "There are no data points to download for this report at the moment."
                    );
                } else {
                    this.openInExcel(result, this.query.fileName);
                }
            },
            error: (err) => {
                this.log.error(
                    "downloadFile got an error: " + JSON.stringify(err)
                );
            },
        });
    }

    // This is not requried
    openInExcel(data, fileName) {
        const blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const fileURL = URL.createObjectURL(blob);

        if (window.navigator && _.has(window.navigator, "msSaveOrOpenBlob")) {
            const nav = window.navigator as any;
            if (nav.msSaveOrOpenBlob) {
                nav.msSaveOrOpenBlob(blob, fileName);
            }
        } else {
            const a = document.createElement("a");
            a.href = fileURL;
            a.target = "_blank";
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
        }
    }

    ngOnInit() {
        this.subscribeEventHandlers();
        this.onBreadcrumb("step1");
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
